import { useQuery } from '@tanstack/react-query'
export { useQueryClient } from '@tanstack/react-query'

import { getFreeeConnected } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchFreeeConnected = (organizationId: string) => {
  const { axiosInstance } = useAxios()
  return useQuery({
    enabled: !!organizationId,
    queryFn: () => getFreeeConnected(axiosInstance, organizationId),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_FREEE_CONNECTED],
  })
}
